import { useEffect, useState } from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";

const SFMainNavbar = () => {
  const pathname = usePathname();
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (pathname === "/configurator/global-options") {
      setTitle("Global Options");
    } else if (pathname === "/configurator/body-options") {
      setTitle("Body Options");
    } else if (pathname.startsWith("/configurator/qm")) {
      setTitle("Quote Management");
    } else if (pathname === "/my-quotes") {
      setTitle("My Quotes");
    } else {
      setTitle("");
    }
  }, [pathname]);

  return (
    <nav
      className={`flex ${title ? "justify-between" : "justify-center"} px-2% shadow-md h-16 items-center relative`}
    >
      <div className="flex justify-center items-center h-14">
        <Image
          src="/assets/duke.png"
          width={100}
          height={100}
          alt="Duke Logo"
          aria-label="logo"
          priority
          className="w-16 h-11 mr-6"
        />
        {title && (
          <div className="border-l-2">
            <h1 className="text-lg font-semibold leading-4 text-primary-700 font-myriad px-3 py-3">
              {title}
            </h1>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SFMainNavbar;
